import dayjs from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday';

import { DATE_PAYLOAD_FORMAT } from '../../constants/formatting';

dayjs.extend(localeData);
dayjs.extend(weekday);
dayjs.extend(LocalizedFormat);

/**
 * Format of date that is passed in `onChange` function for example,
 * also recommended format to use when passing selected value to DatePicker
 */
export const DATE_PICKER_FORMAT = DATE_PAYLOAD_FORMAT;

/**
 * Format used to display value in date picker
 */
export const DATE_PICKER_DISPLAY_FORMAT = 'MMM DD, YYYY';

/**
 * @deprecated please use DATE_PICKER_DISPLAY_FORMAT instead
 */
export const DISPLAY_FORMAT = DATE_PICKER_DISPLAY_FORMAT;

export const DATE_PICKER_EARLIEST_DATE = '1970-01-01';

export const DAY_PICKER_SUNDAY_INDEX = 0;
export const DAY_PICKER_MONDAY_INDEX = 1;
export const DAY_PICKER_SATURDAY_INDEX = 6;

const prefix = 'hc-date-picker';

/**
 * Collection of class names inside Input component.
 *
 * These styles basically only mark input component in named way in case you want to override styles in parent
 */
export const DatePickerClassNames = {
  Root: `${prefix}-root`,
  PopoverContent: `${prefix}-popover-content`,
  InputRoot: `${prefix}-input-root`,
  InputLabel: `${prefix}-input-label`,
  InputMainWrapper: `${prefix}-input-main-wrapper`,
  InputMain: `${prefix}-input-main`,
  InputError: `${prefix}-input-error`,
};
